// extracted by mini-css-extract-plugin
export default {"container":"styles-scoped__container--r_tC1","icon":"styles-scoped__icon--_eOff","btnIcon":"styles-scoped__btnIcon--VF9_f"};